import React, { useEffect, useMemo, useRef } from 'react';
import { compose } from 'recompose';
import propTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import sToastMessage from './toastMessage.module.scss';
// https://fkhadra.github.io/react-toastify/how-to-style/#passing-css-classes-to-component

export const enhance = compose(withStyles(sToastMessage));

function ToastMessage({ newestOnTop = true, renderContainer = false, ...props }) {
  const onCloseRef = useRef(props.onClose);
  onCloseRef.current = props.onClose;

  const resolvedToastId = useMemo(() => {
    if (props.id) return props.id;
    const status = props.isSuccess ? 'success' : 'failure';
    return `${status}-${props.message || ''}`;
  }, [props.id, props.isSuccess, props.message]);

  useEffect(() => {
    if (!props.show || !props.message?.length) return;
    if (toast.isActive(resolvedToastId)) return;

    toast(props.message, {
      toastId: resolvedToastId,
      autoClose: props.isSuccess ? 5000 : 7000,
      // react-toastify v11+ merged toast/body into one node; `bodyClassName` / `toastClassName` are ignored.
      icon: false,
      className: props.isSuccess
        ? sToastMessage['successContainer']
        : !props.isSuccess
          ? sToastMessage['failureContainer']
          : sToastMessage['container'],
      progressClassName: sToastMessage['progress-bar'],
      onClose: () => {
        if (onCloseRef.current) onCloseRef.current(true);
      },
    });
  }, [props.show, props.message, props.isSuccess, resolvedToastId]);

  if (!renderContainer) {
    return null;
  }

  return (
    <div>
      <ToastContainer
        position="bottom-right"
        autoClose={!props.isSuccess ? 7000 : 5000}
        hideProgressBar
        newestOnTop={newestOnTop}
        closeOnClick
        closeButton={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        role="alert"
        style={{
          marginBottom: '45px',
          marginRight: '56px',
          marginLeft: '10px',
          zIndex: 99999,
        }}
      />
    </div>
  );
}

ToastMessage.propTypes = {
  message: propTypes.string,
  onClose: propTypes.func,
  show: propTypes.bool,
  newestOnTop: propTypes.bool,
  id: propTypes.string,
  renderContainer: propTypes.bool,
};

export default enhance(ToastMessage);
